export default "__VITE_ASSET__SelKiGwN__"